import { Provider } from 'modules/transmission/types'
import { ProviderOption } from 'modules/transmission/components/transmission-form/types'

class ProviderHelper {
  static isHotmart = (providerOption: ProviderOption) => {
    return providerOption === ProviderOption.HOTMART
  }

  static isYoutubeHotmart = (providerOption: ProviderOption) => {
    return providerOption === ProviderOption.YOUTUBE_HOTMART
  }

  static isExternal = (providerOption: ProviderOption) => {
    return providerOption === ProviderOption.EXTERNAL
  }

  static mapOptionToProvider = (providerOption: ProviderOption) => {
    switch (providerOption) {
      case ProviderOption.HOTMART:
        return Provider.HOTMART
      case ProviderOption.YOUTUBE_HOTMART:
        return Provider.YOUTUBE_HOTMART
      case ProviderOption.MUX_STUDIO_HOTMART:
        return Provider.MUX_STUDIO_HOTMART
      default:
        return null
    }
  }

  static mapProviderToOption = (provider: Provider) => {
    switch (provider) {
      case Provider.HOTMART:
        return ProviderOption.HOTMART
      case Provider.YOUTUBE_HOTMART:
        return ProviderOption.YOUTUBE_HOTMART
      case Provider.MUX_STUDIO_HOTMART:
        return ProviderOption.MUX_STUDIO_HOTMART
      default:
        return ProviderOption.EXTERNAL
    }
  }
}

export default ProviderHelper
